/* GenericText.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._1e0c116y{display:inline-flex}";
const _11 = "._k48pni7l{font-weight:600}";
const _10 = "._18u0idpf{margin-left:0}";
const _9 = "._otyridpf{margin-bottom:0}";
const _8 = "._2hwxidpf{margin-right:0}";
const _7 = "._19pkidpf{margin-top:0}";
const _6 = "._1e0c1nu9{display:inline}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal, H6, Link, LinkWithIcon } from '@atlassian/mpac-primitives';
import React from 'react';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._1x8w11lx{list-style-position:outside}";
const _4 = "._19bvidpf{padding-left:0}";
const _3 = "._n3tdidpf{padding-bottom:0}";
const _2 = "._u5f3idpf{padding-right:0}";
const _ = "._ca0qidpf{padding-top:0}";
const ContainerUl = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1x8w11lx", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContainerUl.displayName = 'ContainerUl';
}
const Text = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1nu9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
const BoldText = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = Text,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BoldText.displayName = 'BoldText';
}
const LinkWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c116y", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LinkWrapper.displayName = 'LinkWrapper';
}
export const GenericText = _ref5 => {
  let {
    items
  } = _ref5;
  const {
    fireQuestionnaireUiLinkEvent,
    fireQuestionnaireUiEmailEvent
  } = usePrivacyAndSecurityAnalytics();
  const group = items.map((item, index) => {
    switch (item.type) {
      case 'heading-with-bullet':
        return /*#__PURE__*/_jsx(ContainerUl, {
          children: /*#__PURE__*/_jsx(H6, {
            as: "p",
            children: item.text
          })
        }, index);
      case 'link-with-icon':
        return /*#__PURE__*/_jsx(LinkWrapper, {
          children: /*#__PURE__*/_jsx(LinkWithIcon, {
            type: "external",
            href: item.href,
            size: "medium",
            "aria-label": "".concat(item.ariaLabel || item.text, " open in new window"),
            onClick: () => fireQuestionnaireUiLinkEvent(item.text),
            children: item.text
          })
        }, index);
      case 'link':
        return /*#__PURE__*/_jsx(Link, {
          size: "medium",
          href: item.href,
          onClick: () => fireQuestionnaireUiLinkEvent(item.text),
          children: item.text
        }, index);
      case 'email':
        return /*#__PURE__*/_jsx(Link, {
          size: "medium",
          href: "mailto:".concat(item.mailId),
          onClick: () => fireQuestionnaireUiEmailEvent(),
          "aria-label": "Send email to ".concat(item.text, " open in Email tool"),
          children: item.text
        }, index);
      case 'text':
        return /*#__PURE__*/_jsx(Text, {
          children: item.text
        }, index);
      case 'bold-text':
        return /*#__PURE__*/_jsx(BoldText, {
          children: item.text
        }, index);
      case 'text-label-bold-data':
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            children: item.text
          }), " ", /*#__PURE__*/_jsx(BoldText, {
            children: item.data
          })]
        }, index);
      case 'bold-text-normal-data':
        return /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(BoldText, {
            children: item.text
          }), "\xA0", /*#__PURE__*/_jsxs(Text, {
            children: [item.data, " "]
          })]
        }, index);
      default:
        return null;
    }
  })
  // why? to add a spacing between two elements so that it feels like a continues text
  .reduce((acc, item) => [...acc, item, ' '], []).slice(0, -1);
  return /*#__PURE__*/_jsx("div", {
    children: group
  });
};